import {
  FilledInputProps,
  InputProps,
  OutlinedInputProps,
  SxProps,
  TextField,
  TextFieldProps,
} from "@mui/material";
import clsx from "clsx";
import styles from "./ui-text-field.module.scss";
import { forwardRef } from "react";
import { ErrorMessage } from "shared/ui/ErrorMessage/ErrorMessage";

export type UiTextFieldProps = {
  className?: string;
  label?: string;
  error?: any | undefined;
  name?: any | undefined;
  inputProps?: TextFieldProps;
  placeholder?: string;
  InputProps?:
    | Partial<FilledInputProps>
    | Partial<OutlinedInputProps>
    | Partial<InputProps>
    | undefined;
  isMessageUnBlock?: boolean;
  type?: string;
  defaultValue?: number | string | undefined;
  sx?: SxProps;
  helperText?: string | undefined;
  inputRef?: any;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
};

export function UiTextField({
  className,
  error,
  label,
  inputProps,
  name,
  placeholder,
  InputProps,
  isMessageUnBlock,
  type = "text",
  inputRef,
  onChange,
  onBlur,
}: UiTextFieldProps) {
  const id = label! + Math.random();
  return (
    <div className={clsx(className, styles.inputWrapper)}>
      <label htmlFor={String(id)} style={{ height: "17px" }} className="block">
        {label}
      </label>
      <TextField
        className={clsx(inputProps?.className, styles.textField)}
        type={type}
        id={String(id)}
        error={!!error}
        focused={!!error}
        placeholder={placeholder}
        size="small"
        name={name}
        inputRef={inputRef}
        onChange={onChange}
        onBlur={onBlur}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "12px",
            border: "2px solid #C0D4E3",
          },
          "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "2px solid #0090D1",
          },
          "& .Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "2px solid #d32f2f",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "2px solid #C0D4E3 !important",
          },
          "& .MuiInputBase-input": {
            fontFamily: "Raleway",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "24px",
            color: "#3E444A",
            padding: "8px 12px",
            "&::placeholder": {
              fontFamily: "Raleway",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "24px",
              color: "rgba(0, 0, 0, 0.6)",
            },
          },
          "& .MuiInputBase-root": {
            height: "40px",
          },
        }}
        inputProps={{
          min: 0,
          step: 1,
          ...(inputProps?.inputProps || {}),
        }}
        {...inputProps}
        InputProps={InputProps}
      />
      {error && <ErrorMessage error={error} />}
    </div>
  );
}
